import { useEffect, useMemo } from "react";
import { useForm, useFormState } from "react-final-form";
import { deleteObjectKeysByPath } from "../../../_src_shared/utils/objects/deleteObjectKeysByPath";
import RffConditional from "../../../components/finalForm/shared/RffConditional";
import RffFieldsRenderer from "../../../components/finalForm/shared/RffFieldsRenderer";
import RffGroup from "../../../components/finalForm/shared/RffGroup";
import { selectOptionsLoanProductTypeQuickApp } from "../../../constants/selectOptions/selectOptionsLoanProductTypeQuickApp";
import { selectOptionsLoanPurposeQuickApp } from "../../../constants/selectOptions/selectOptionsLoanPurposeQuickApp";
import { loanQuickAppFormKeys as FMK } from "../../../constants/models/forms/loanQuickAppFormKeys";

const LCK = FMK.loanRelatedContacts[0];
const CONTACT_KEY_NAME = "loanRelatedContacts[0]";
const LoanQuickAppStepOneBorrowerDetails = ({ setIncludesBroker }) => {
  const { values } = useFormState();
  const { change } = useForm();
  const fields = useMemo(
    () => [
      {
        name: FMK.hasClosedWithLenderBefore,
        label: "Have you Closed with Lendmarq Before?",
        type: "booleanToggle",
        required: true,
      },
      {
        name: FMK.isBrokeredLoan,
        label: "Is this a Brokered Loan?",
        type: "booleanToggle",
        required: true,
      },
      {
        name: FMK.loanPurpose,
        label: "What kind of loan are you looking for?",
        type: "selectToggle",
        required: true,
        options: selectOptionsLoanPurposeQuickApp,
      },

      {
        name: FMK.loanProductType,
        label: "What Kind of Real Estate Investment are you Considering? ",
        type: "selectToggle",
        required: true,
        options: selectOptionsLoanProductTypeQuickApp,
      },
    ],
    []
  );

  const brokerFields = useMemo(
    () => [
      {
        size: 6,
        name: `${CONTACT_KEY_NAME}.${LCK.firstName}`,
        label: "First Name",
        type: "text",
        required: true,
      },
      {
        size: 6,
        name: `${CONTACT_KEY_NAME}.${LCK.lastName}`,
        label: "Last Name",
        type: "text",
        required: true,
      },
      {
        name: `${CONTACT_KEY_NAME}.${LCK.phone}`,
        label: "Phone Number",
        type: "phone",
      },
      {
        name: `${CONTACT_KEY_NAME}.${LCK.emailAddress}`,
        label: "Email",
        type: "email",
      },
      {
        name: `${CONTACT_KEY_NAME}.${LCK.company}`,
        label: "Company",
        type: "text",
      },
    ],
    []
  );

  useEffect(() => {
    if (values?.isBrokeredLoan) {
      setIncludesBroker(true);
      change("loanRelatedContacts", [{ loanRole: "Broker Contact" }]);
      // change(values, { loanRelatedContacts: [{ loanRole: "Broker Contact" }] });
    } else {
      const updated = deleteObjectKeysByPath(values, ["loanRelatedContacts"]);
      // const updated = deleteObjectKeysByPath(values, [
      //   FMK.brokerFirstName,
      //   FMK.brokerLastName,
      //   FMK.brokerPhone,
      //   FMK.brokerEmail,
      //   FMK.brokerCompany,
      // ]);
      change(values, updated);
      setIncludesBroker(false);
    }
  }, [values?.isBrokeredLoan]);
  return (
    <>
      <RffGroup title="Basic Information">
        <RffFieldsRenderer fields={fields} />
      </RffGroup>
      <RffConditional field={FMK.isBrokeredLoan} value={true}>
        <RffGroup title="Broker Contact Info">
          <RffFieldsRenderer fields={brokerFields} />
        </RffGroup>
      </RffConditional>
    </>
  );
};

export default LoanQuickAppStepOneBorrowerDetails;
